import { render } from "./MerchantRequestLogModal.vue?vue&type=template&id=3d75a12a&ts=true"
import script from "./MerchantRequestLogModal.vue?vue&type=script&lang=ts"
export * from "./MerchantRequestLogModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__